<template>
	<div class="d-flex flex-row no-gutters h-100 w-100 provider-content" ref="container">
		<div :class='"position-relative bg-light border-right-separator no-gutters h-100 column-list column-list" + event'>
			<loading ref="loading"></loading>
			<div class='d-flex flex-column h-100'>
				<header class="list-header" style="z-index: 100;">

                    <slot name="header">
                        
                    </slot>
					
                    <slot name="quick_filters">
                        
                    </slot>

                    <slot name="site_select">
                        
                    </slot>
                    
				</header>

                <slot name='filter'>
                    
                </slot>

                <slot name='current-filter'>
                    
                </slot>

				<div class="errors">
	                <template v-for="(error) in errors">
	                    <p class="alert alert-warning" v-bind:key='message' v-for="message in error">{{message}}</p>
	                </template>
	            </div>

				<div class='flex-grow-1-scroll h-100'>
					<div class="p-2" v-show='items.data instanceof Array && items.data.length === 0'>{{$t('translations.no_items_found')}}.</div>
					<slot name='list'></slot>
				</div>

				<footer class='list-footer'>
					<div class="d-flex flex-row flex-wrap align-items-stretch justify-content-between">
						<button v-if='create' class="align-self-center btn btn-circle mr-2" v-on:click="$emit('create')">
							<span class="fa fa-plus"></span>
						</button>
						<!-- <pagination :limit="0" ref="paginator" :data="items" v-on:pagination-change-page="getResults" ></pagination> -->
						<paginator v-if='items.current_page' class='align-self-center small' :pagination="items"
		                     @paginate='$emit("paginate")'
							 :offset="1"
                             :simple="true">
						</paginator>

						<slot name='sort'>
                        </slot>
                        
                        <slot name='perpage'>
                        </slot>


					</div>
				</footer>
			</div>
		</div>

		<div class="flex-grow-1-scroll h-100 w-100">
			<global-message ref="globalmessage"></global-message>

            <slot name='selectedcontent'>
            </slot>

		</div>
	</div>

</template>

<script>
export default {
		props: {
            items: {},
			route: {},
			event: {},
			model: {},
			// @todo Review this as we can just use this.$router.path
			path: {},
			title: {},
			displayelement: {},
			modalid: {},
			subroute: {
				default: 1
            },
            create: {
                default: 1
            },
            errors: {},
        }
}
</script>